<template>
  <div class="introduction-container">
    <div class="breadcrumbs mb-40">
      <breadcrumb
        path="/documentation/webhook/open-order-update-status"
        name="Overview"
        :route-name="route.name"
        :is-tool="true"
        :is-webhook="true"
        :data-webhook="dataRequest"
      />
    </div>
    <div class="title">
      {{ title }}
    </div>
    <div class="submenu-container">
      <div class="mb-40">
        Use this call to {{ subTitle }}.
      </div>
      <div class="mb-14">
        <div class="font-w-semi-bold font-18">
          Common Parameters
        </div>
        <common-table
          :data-table-common-url="dataTableCommonUrl"
          :data-table-common-name="dataTableCommonName"
        />
      </div>
      <div class="mt-40 mb-24 font-w-semi-bold">
        <div class="font-w-semi-bold font-18">
          Request Example
        </div>
        <code-editor
          :data="dataRequest"
          title="JSON"
          style="width: 1000px"
          @copyToClipboard="copyToClipboard"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'
import CodeEditor from '../components/_codeEditor.vue'
import CommonTable from '../components/_commonTable.vue'

const route = useRoute()
const title = computed(() => route.name)
const subTitle = computed(() => route.name.toLowerCase())
const dataRequest = ref({
  flag_webhook: 'openOrderUpdateStatus',
  openorder_id: 1189947414,
  order_no: 'OL22092200000002',
  store_id: 95325,
  status: 'P',
  modified_time: '2022-09-28 14:17:05',
  modified_by: 'akmal@olsera.com'
})
const dataTableCommonUrl = ref([])
const dataTableCommonName = ref([])

onMounted(() => {
  getDataCommon()
})

const getDataCommon = () => {
  dataTableCommonUrl.value.push({
    name: 'URL',
    url: 'https://yourdomain.test'
  })
  dataTableCommonName.value.push({
    name: 'Method',
    method: 'POST'
  })
}

const copyToClipboard = (data) => {
  navigator.clipboard.writeText(data)
}
</script>
